import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowRight, CheckCircle, Star, Users, Award, Calendar, GraduationCap } from 'lucide-react';
import { fetchPrograms, fetchTestimonials, fetchStats } from '../services/api';

const CarouselPresentation = () => {
  const [activeSlide, setActiveSlide] = useState(0);

  const goTo = (idx) => {
    setActiveSlide(idx);
  };

  const cardStyle = {
    background: 'linear-gradient(135deg, #fff 0%, #FFF0F3 100%)',
    border: '2px solid #E75480',
    borderRadius: '1rem',
    padding: '2.5rem 1.25rem 1.75rem 1.25rem',
    position: 'relative',
    boxShadow: '0 4px 20px rgba(231, 84, 128, 0.12)',
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start'
  };

  return (
    <div>
      <div style={{ position: 'relative', width: '100%', paddingTop: '1rem' }}>
        {/* Slide 1 */}
        <div style={{
          opacity: activeSlide === 0 ? 1 : 0,
          position: activeSlide === 0 ? 'relative' : 'absolute',
          top: 0, left: 0, width: '100%',
          transition: 'opacity 0.4s ease',
          pointerEvents: activeSlide === 0 ? 'auto' : 'none',
          boxSizing: 'border-box'
        }}>
          <div style={cardStyle}>
          <div style={{
            display: 'block', marginBottom: '1.25rem', textAlign: 'center'
          }}>
            <span style={{
              background: '#E75480', color: 'white', fontWeight: 700,
              fontSize: '1rem', padding: '0.5rem 1.5rem', borderRadius: '2rem',
              letterSpacing: '0.05em', textTransform: 'uppercase'
            }}>
              Votre accompagnatrice
            </span>
          </div>
          <p style={{ marginBottom: '1rem', color: '#4A3050', lineHeight: 1.8, fontSize: '0.9rem' }}>
            Je suis <strong style={{ color: '#E75480' }}>Rose</strong>, accompagnatrice VAE depuis plus de <strong>10 ans</strong> et membre de jury depuis <strong>13 ans</strong> dans le secteur sanitaire, social et de la petite enfance.
          </p>
          <p style={{ color: '#4A3050', lineHeight: 1.8, fontSize: '0.9rem', marginBottom: '1rem' }}>
            Je suis titulaire du <strong style={{ color: '#E75480' }}>DEAP</strong>, du <strong style={{ color: '#E75480' }}>DEEJE</strong> et du <strong style={{ color: '#E75480' }}>CAFERUIS</strong>. Je suis également formée en <strong>psychanalyse</strong> et en <strong>sophrologie</strong>, ce qui me permet d'accompagner les candidats à la fois sur le plan méthodologique et sur la confiance en soi face aux étapes de la VAE.
          </p>
          <p style={{ color: '#6B5B7A', lineHeight: 1.7, fontSize: '0.85rem', marginBottom: '1rem' }}>
            J'accompagne les candidats dans leur réflexion, la rédaction de leur livret 2 et la préparation de leur oral afin de leur donner toutes les clés pour réussir leur certification.
          </p>
          <p style={{ color: '#6B5B7A', lineHeight: 1.7, fontSize: '0.85rem', marginBottom: 0 }}>
            Les formations proposées sur cet espace ont été conçues à partir des besoins réels des candidats. Elles vous apportent des outils pédagogiques concrets pour comprendre les attentes du jury et avancer efficacement dans votre démarche VAE, même en autonomie.
          </p>

          {/* Filler to balance height + hint to swipe */}
          <div style={{ marginTop: 'auto', paddingTop: '1.5rem' }}>
            <div style={{
              display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '0.75rem', marginBottom: '1.25rem'
            }}>
              {[
                { num: '10+', label: "ans d'expérience" },
                { num: '94%', label: 'taux de réussite' },
                { num: '3', label: 'diplômes VAE' },
                { num: '13', label: 'ans membre jury' }
              ].map((stat, i) => (
                <div key={i} style={{
                  textAlign: 'center', padding: '1rem 0.5rem',
                  background: '#FFF0F3', borderRadius: '0.75rem', border: '1px solid #F9A8D4'
                }}>
                  <div style={{ fontSize: '1.5rem', fontWeight: 800, color: '#E75480', lineHeight: 1 }}>{stat.num}</div>
                  <div style={{ fontSize: '0.7rem', color: '#B44D6E', marginTop: '0.3rem', fontWeight: 500 }}>{stat.label}</div>
                </div>
              ))}
            </div>
            <div
              onClick={() => goTo(1)}
              style={{
                textAlign: 'center', cursor: 'pointer', padding: '0.75rem',
                borderRadius: '0.75rem', background: 'linear-gradient(135deg, #FFF0F3, #FCE7F3)',
                border: '1px dashed #E75480', transition: 'all 0.3s'
              }}
            >
              <p style={{ color: '#E75480', fontWeight: 700, fontSize: '0.95rem', margin: 0 }}>
                Découvrir mon parcours personnel &#8594;
              </p>
              <p style={{ color: '#B44D6E', fontSize: '0.8rem', margin: '0.25rem 0 0' }}>
                Glissez ou cliquez pour la suite
              </p>
            </div>
          </div>
        </div>
        </div>

        {/* Slide 2 — Texte personnel */}
        <div style={{
          opacity: activeSlide === 1 ? 1 : 0,
          position: activeSlide === 1 ? 'relative' : 'absolute',
          top: 0, left: 0, width: '100%',
          transition: 'opacity 0.4s ease',
          pointerEvents: activeSlide === 1 ? 'auto' : 'none',
          boxSizing: 'border-box'
        }}>
        <div style={cardStyle}>
          <div style={{
            display: 'block', marginBottom: '1.25rem', textAlign: 'center'
          }}>
            <span style={{
              background: '#E75480', color: 'white', fontWeight: 700,
              fontSize: '1rem', padding: '0.5rem 1.5rem', borderRadius: '2rem',
              letterSpacing: '0.05em', textTransform: 'uppercase'
            }}>
              Mon parcours
            </span>
          </div>
          <p style={{ fontSize: '1.15rem', fontWeight: 700, color: '#E75480', marginBottom: '1rem', lineHeight: 1.6 }}>
            La VAE n'est pas un dossier. C'est un révélateur.
          </p>
          <p style={{ color: '#4A3050', lineHeight: 1.8, fontSize: '0.95rem', marginBottom: '0.75rem' }}>
            Je ne parle pas en théorie. J'ai obtenu mon <strong style={{ color: '#E75480' }}>DEEJE</strong> puis mon <strong style={{ color: '#E75480' }}>CAFERUIS</strong> par la VAE, en étant maman de quatre enfants et directrice de crèche.
          </p>
          <p style={{ color: '#4A3050', lineHeight: 1.7, fontSize: '0.9rem', marginBottom: '0.5rem' }}>J'ai connu :</p>
          <ul style={{ color: '#4A3050', lineHeight: 1.8, fontSize: '0.9rem', marginBottom: '0.75rem', paddingLeft: '1.25rem' }}>
            <li>les dossiers écrits tard le soir après la journée en structure</li>
            <li>la charge mentale permanente</li>
            <li>le doute, la fatigue, l'exigence</li>
            <li>et cette <strong>fierté immense</strong> quand tout prend sens</li>
          </ul>
          <p style={{ color: '#4A3050', lineHeight: 1.8, fontSize: '0.95rem', marginBottom: '0.75rem' }}>
            Mais ce que la VAE m'a surtout apporté, ce n'est pas un diplôme. C'est une <strong>posture</strong>. Une <strong>légitimité</strong>. Une capacité à <strong>prendre ma place</strong>.
          </p>
          <div style={{ borderLeft: '3px solid #E75480', paddingLeft: '1rem', margin: '0.75rem 0' }}>
            <p style={{ color: '#4A3050', lineHeight: 1.7, fontSize: '0.9rem', marginBottom: '0.5rem' }}>
              Aujourd'hui, j'accompagne les professionnels de la petite enfance qui veulent faire reconnaître leur expertise et évoluer avec solidité.
            </p>
            <p style={{ color: '#4A3050', lineHeight: 1.7, fontSize: '0.9rem', marginBottom: 0 }}>
              Je ne fais pas "remplir des livrets". Je vous aide à <strong>structurer votre pensée</strong>, <strong>clarifier votre pratique</strong> et <strong>incarner votre positionnement</strong>.
            </p>
          </div>
          <p style={{ color: '#4A3050', lineHeight: 1.7, fontSize: '0.9rem', margin: '0.75rem 0' }}>
            Je suis également <strong>jury pour le DAVA et l'ASP</strong>. Je connais le dispositif des deux côtés. Je sais ce qui fait la différence face à un jury.
          </p>
          <p style={{ color: '#4A3050', lineHeight: 1.7, fontSize: '0.9rem', marginBottom: '0.5rem' }}>Parce que derrière chaque dossier, il y a :</p>
          <ul style={{ color: '#4A3050', lineHeight: 1.8, fontSize: '0.9rem', marginBottom: '0.75rem', paddingLeft: '1.25rem' }}>
            <li>une professionnelle engagée</li>
            <li>un parcours souvent invisible</li>
            <li>une valeur qui mérite d'être reconnue</li>
          </ul>
          <p style={{ fontSize: '1.05rem', fontWeight: 700, color: '#E75480', textAlign: 'center' }}>
            Vous préparez une VAE ? Parlons-en ensemble.
          </p>
        </div>
        </div>
      </div>

      {/* Dots + arrows */}
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1rem', marginTop: '1.25rem', marginBottom: '0.5rem' }}>
        <button onClick={() => goTo(0)} style={{
          background: 'none', border: 'none', cursor: 'pointer', fontSize: '2rem', color: '#E75480', padding: '0.25rem', fontWeight: 700
        }} aria-label="Précédent">&#8249;</button>
        {[0, 1].map(i => (
          <button key={i} onClick={() => goTo(i)} style={{
            width: activeSlide === i ? '32px' : '14px',
            height: '14px',
            borderRadius: '7px',
            background: activeSlide === i ? '#E75480' : '#F9A8D4',
            border: activeSlide === i ? '2px solid #E75480' : '2px solid #F9A8D4',
            cursor: 'pointer',
            transition: 'all 0.3s',
            padding: 0
          }} aria-label={`Slide ${i + 1}`} />
        ))}
        <button onClick={() => goTo(1)} style={{
          background: 'none', border: 'none', cursor: 'pointer', fontSize: '2rem', color: '#E75480', padding: '0.25rem', fontWeight: 700
        }} aria-label="Suivant">&#8250;</button>
      </div>
      <p style={{ textAlign: 'center', color: '#B44D6E', fontSize: '0.75rem', fontWeight: 500, margin: 0 }}>
        {activeSlide === 0 ? '1/2 — Votre accompagnatrice' : '2/2 — Mon parcours'}
      </p>

    </div>
  );
};

const LandingPage = () => {
  const navigate = useNavigate();
  const [VAE_PROGRAMS, setPrograms] = useState([]);
  const [MOCK_TESTIMONIALS, setTestimonials] = useState([]);
  const [MOCK_STATS, setStats] = useState({ successRate: 94, totalCandidates: 847, averageRating: 4.8, yearsExperience: 12 });

  useEffect(() => {
    fetchPrograms().then(setPrograms).catch(console.error);
    fetchTestimonials().then(setTestimonials).catch(console.error);
    fetchStats().then(setStats).catch(console.error);
  }, []);

  return (
    <div style={{ paddingTop: '70px', overflowX: 'hidden', maxWidth: '100vw', width: '100%' }}>
      {/* Hero Section */}
      <section className="hero-section">
        <div style={{ maxWidth: '900px', margin: '0 auto', position: 'relative', zIndex: 2, padding: '0 1rem', width: '100%', boxSizing: 'border-box' }}>
          {/* Logo APDR en grand sur toute la largeur */}
          <div style={{ marginBottom: '2rem', display: 'flex', justifyContent: 'center' }}>
            <Link to="/">
              <img 
                src="/logo-apdr.png" 
                alt="APDR de la VAE - Valoriser l'expérience, révéler les compétences" 
                style={{ 
                  width: '100%',
                  maxWidth: '900px',
                  height: 'auto',
                  display: 'block'
                }} 
              />
            </Link>
          </div>

          <h1 className="heading-hero" style={{ marginBottom: '1.5rem', paddingTop: '1.5rem', wordBreak: 'break-word' }}>
            Bonjour et bienvenue dans l'aventure VAE
          </h1>

          <div style={{ maxWidth: '700px', marginLeft: 'auto', marginRight: 'auto', textAlign: 'left', marginBottom: '2rem', position: 'relative' }}>
            {/* Carousel */}
            <CarouselPresentation />
          </div>

        </div>
      </section>

      {/* Programs Preview */}
      <section style={{ padding: '5rem 1.2rem' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h2 className="heading-1" style={{ marginBottom: '1rem' }}>
              Nos Formations VAE
            </h2>
            <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
              Choisissez le diplôme qui correspond à votre expérience
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(min(300px, 100%), 1fr))',
            gap: '1.5rem'
          }}>
            {VAE_PROGRAMS.filter(p => !['oral-vae', 'livret-1-asp', 'veille-professionnelle', 'veille-pro'].includes(p.id)).map((program) => {
              const DIPLOMA_LEVELS = {
                'cap-aepe': { level: 'Niveau 3', rncp: 'RNCP 38565', certif: 'Certificateur Ministère de l\'Éducation Nationale', date: '22/01/2024' },
                'deap': { level: 'Niveau 4', rncp: 'RNCP 40743', certif: 'Certificateur Dreets', date: '12/06/2021' },
                'deeje': { level: 'Niveau 6', rncp: 'RNCP 37679', certif: 'Certificateur Dreets', date: '09/04/2020' },
                'caferuis': { level: 'Niveau 6', rncp: 'RNCP 36836', certif: 'Certificateur Dreets, Ministère de la Solidarité', date: '31/08/2022' },
                'tp': { level: 'Niveau 4', rncp: 'RNCP 41849', certif: 'Certificateur Ministère chargé de l\'Emploi', date: '15/12/2025' },
                'bac-assp': { level: 'Niveau 4', rncp: 'RNCP 37231', certif: 'Certificateur Dava, Ministère de l\'Éducation nationale', date: '04/03/2022' },
                'deas': { level: 'Niveau 4', rncp: 'RNCP 40692', certif: 'Certificateur Dreets', date: '12/06/2021' }
              };
              const diplomaInfo = DIPLOMA_LEVELS[program.id] || { level: '—', rncp: '', certif: '', date: '' };
              return (
                <div 
                  key={program.id} 
                  className={`card accent-${program.color} hover-lift`}
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    flexDirection: 'column',
                    border: '2px solid #d4af37',
                    boxShadow: '0 0 12px rgba(212, 175, 55, 0.35), inset 0 0 4px rgba(212, 175, 55, 0.08)',
                    transition: 'box-shadow 0.3s, transform 0.3s'
                  }}
                  onClick={() => navigate(`/programs/${program.id}`)}
                  onMouseEnter={e => e.currentTarget.style.boxShadow = '0 0 22px rgba(212, 175, 55, 0.55), inset 0 0 6px rgba(212, 175, 55, 0.12)'}
                  onMouseLeave={e => e.currentTarget.style.boxShadow = '0 0 12px rgba(212, 175, 55, 0.35), inset 0 0 4px rgba(212, 175, 55, 0.08)'}
                  data-testid={`landing-program-${program.id}`}
                >
                  <div style={{ 
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '1rem'
                  }}>
                    <span style={{
                      padding: '0.25rem 0.75rem',
                      background: 'rgba(255, 255, 255, 0.6)',
                      borderRadius: '1rem',
                      fontSize: '0.7rem',
                      fontFamily: 'var(--font-mono)',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }}>
                      {program.title}
                    </span>
                    <span style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.35rem',
                      padding: '0.25rem 0.75rem',
                      background: 'rgba(0,0,0,0.06)',
                      borderRadius: '1rem',
                      fontSize: '0.7rem',
                      fontWeight: 600
                    }}>
                      <GraduationCap size={14} />
                      {diplomaInfo.level}
                    </span>
                  </div>

                  <h3 className="heading-2" style={{ marginBottom: '0.75rem' }}>
                    {program.fullName}
                  </h3>

                  <p className="body-small" style={{ 
                    marginBottom: '1rem',
                    flex: 1,
                    color: 'var(--text-secondary)'
                  }}>
                    {program.description}
                  </p>

                  {diplomaInfo.rncp && (
                    <div style={{
                      background: 'rgba(0,0,0,0.03)',
                      borderRadius: '8px',
                      padding: '0.5rem 0.75rem',
                      marginBottom: '1rem',
                      fontSize: '0.7rem',
                      color: 'var(--text-muted)',
                      lineHeight: 1.5
                    }}>
                      <strong style={{ color: 'var(--text-secondary)' }}>{diplomaInfo.rncp}</strong> · {diplomaInfo.certif}<br />
                      Enregistrement au RNCP : {diplomaInfo.date}
                    </div>
                  )}

                  <div style={{ 
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    paddingTop: '1rem',
                    borderTop: '1px solid var(--border-light)'
                  }}>
                    <button 
                      className="btn-primary"
                      style={{ padding: '0.5rem 1.25rem', fontSize: '0.75rem', gap: '0.5rem' }}
                    >
                      <span>Voir détails</span>
                      <ArrowRight size={16} />
                    </button>
                  </div>
                </div>
              );
            })}
          </div>

          <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <Link to="/programs" className="btn-secondary">
              Comment fonctionne votre accompagnement
            </Link>
          </div>
        </div>
      </section>

      {/* Features */}
      <section style={{ padding: '5rem 1.2rem', background: 'var(--bg-section)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h2 className="heading-1" style={{ marginBottom: '1rem' }}>
              Pourquoi choisir notre accompagnement ?
            </h2>
          </div>

          <div className="grid-responsive-3">
            <div className="card" style={{ textAlign: 'center' }}>
              <div style={{ 
                background: 'var(--accent-purple-200)', 
                width: '60px', 
                height: '60px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1rem'
              }}>
                <Users size={28} />
              </div>
              <h3 className="heading-3" style={{ marginBottom: '0.75rem' }}>
                Accompagnement personnalisé
              </h3>
              <p className="body-small">
                Un accompagnateur dédié vous guide tout au long de votre parcours VAE
              </p>
            </div>

            <div className="card" style={{ textAlign: 'center' }}>
              <div style={{ 
                background: 'var(--accent-blue-200)', 
                width: '60px', 
                height: '60px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1rem'
              }}>
                <Award size={28} />
              </div>
              <h3 className="heading-3" style={{ marginBottom: '0.75rem' }}>
                Plateforme d'apprentissage
              </h3>
              <p className="body-small">
                Accédez à des cours en ligne, vidéos, quiz et documents pour réussir votre VAE
              </p>
            </div>

            <div className="card" style={{ textAlign: 'center' }}>
              <div style={{ 
                background: 'var(--accent-orange-200)', 
                width: '60px', 
                height: '60px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1rem'
              }}>
                <Calendar size={28} />
              </div>
              <h3 className="heading-3" style={{ marginBottom: '0.75rem' }}>
                Réservation en ligne
              </h3>
              <p className="body-small">
                Planifiez vos séances d'accompagnement directement en ligne selon vos disponibilités
              </p>
            </div>

            <div className="card" style={{ textAlign: 'center' }}>
              <div style={{ 
                background: 'var(--accent-green-200)', 
                width: '60px', 
                height: '60px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1rem'
              }}>
                <Star size={28} />
              </div>
              <h3 className="heading-3" style={{ marginBottom: '0.75rem' }}>
                Experts certifiés
              </h3>
              <p className="body-small">
                Nos accompagnateurs sont formés et certifiés dans leur domaine d'expertise
              </p>
            </div>

            <div className="card" style={{ textAlign: 'center' }}>
              <div style={{ 
                background: 'var(--accent-pink-200)', 
                width: '60px', 
                height: '60px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1rem'
              }}>
                <CheckCircle size={28} />
              </div>
              <h3 className="heading-3" style={{ marginBottom: '0.75rem' }}>
                Suivi de progression
              </h3>
              <p className="body-small">
                Visualisez votre avancement et restez motivé tout au long de votre parcours
              </p>
            </div>

            <div className="card" style={{ textAlign: 'center' }}>
              <div style={{ 
                background: 'var(--accent-grey-200)', 
                width: '60px', 
                height: '60px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1rem'
              }}>
                <Award size={28} />
              </div>
              <h3 className="heading-3" style={{ marginBottom: '0.75rem' }}>
                Taux de réussite élevé
              </h3>
              <p className="body-small">
                94% de nos candidats obtiennent leur diplôme dès la première présentation
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section style={{ padding: '5rem 1.2rem' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h2 className="heading-1" style={{ marginBottom: '1rem' }}>
              Ils ont réussi avec nous
            </h2>
            <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
              Découvrez les témoignages de nos candidats
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(min(300px, 100%), 1fr))',
            gap: '2rem'
          }}>
            {MOCK_TESTIMONIALS.map((testimonial) => (
              <div key={testimonial.id} className="card hover-lift">
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                  {testimonial.avatar ? (
                    <img 
                      src={testimonial.avatar} 
                      alt={testimonial.name}
                      style={{ 
                        width: '50px', 
                        height: '50px', 
                        borderRadius: '50%',
                        objectFit: 'cover'
                      }}
                    />
                  ) : (
                    <div style={{
                      width: '50px',
                      height: '50px',
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, #E75480, #d4af37)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontWeight: 700,
                      fontSize: '1.1rem',
                      flexShrink: 0
                    }}>
                      {testimonial.name?.charAt(0)}
                    </div>
                  )}
                  <div style={{ flex: 1 }}>
                    <h4 className="heading-3" style={{ marginBottom: '0.25rem' }}>
                      {testimonial.name}
                    </h4>
                    <p className="caption">{testimonial.program}</p>
                  </div>
                  <div style={{ display: 'flex', gap: '0.25rem' }}>
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} size={16} fill="currentColor" style={{ color: '#FFA500' }} />
                    ))}
                  </div>
                </div>
                <p className="body-small" style={{ fontStyle: 'italic' }}>
                  "{testimonial.comment}"
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ padding: '4rem 1.2rem', background: 'var(--bg-section)' }}>
        <div className="container" style={{ maxWidth: '700px' }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: '2rem'
          }}>
            <div style={{ textAlign: 'center' }}>
              <div className="heading-1" style={{ color: '#E75480', marginBottom: '0.25rem' }}>
                {MOCK_STATS.successRate}%
              </div>
              <div className="body-small">Taux de réussite</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div className="heading-1" style={{ color: '#E75480', marginBottom: '0.25rem' }}>
                {MOCK_STATS.totalCandidates}+
              </div>
              <div className="body-small">Candidats accompagnés</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div className="heading-1" style={{ color: '#E75480', marginBottom: '0.25rem' }}>
                {MOCK_STATS.averageRating}/5
              </div>
              <div className="body-small">Satisfaction</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div className="heading-1" style={{ color: '#E75480', marginBottom: '0.25rem' }}>
                {MOCK_STATS.yearsExperience}
              </div>
              <div className="body-small">Années d'expérience</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{ 
        padding: '5rem 1.2rem',
        background: 'var(--gradient-hero-warm)',
        textAlign: 'center'
      }}>
        <div className="container" style={{ maxWidth: '700px' }}>
          <h2 className="heading-1" style={{ marginBottom: '1rem' }}>
            Prêt à valider votre expérience ?
          </h2>
          <p className="body-large" style={{ marginBottom: '2rem' }}>
            Commencez votre parcours VAE dès aujourd'hui avec un accompagnement personnalisé
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/register" className="btn-primary">
              Créer mon compte
            </Link>
            <Link to="/booking" className="btn-secondary">
              Réserver une consultation
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LandingPage;
